import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import { DIMENSIONS } from '../../../styles/constants';
import { useStyles } from '../styles';
import Paper from '../../Paper/Paper';
import Grid from '@material-ui/core/Grid';

const QuickFiltersSkeleton = ({ numberOfRows }) => {
	const classes = useStyles();
	const theme = useTheme();

	return (
		<Paper>
			<div className={classes.tableBarBottom}>
				<Skeleton width="170px" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
			</div>
			<Grid container>
				<Grid style={{ width: '720px' }}>
					{[...Array(numberOfRows)].map((_e, index) => (
						<div key={'table-skeleton-row-' + index} className={classes.tableRowButton}>
							<Skeleton width={`calc(100% - ${theme.spacing(3)})px`} height="100%" className={classes.skeleton} />
						</div>
					))}
				</Grid>
				<Grid style={{ width: '250px' }}>
					<div>
						<Skeleton width="100%" height={DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT} className={classes.skeletonNarrow} />
					</div>

					<div>
						<Skeleton width="100%" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} className={classes.skeletonNarrow} />
					</div>

					<div>
						<Skeleton width="100%" height={DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT} className={classes.skeleton} />
					</div>
				</Grid>
			</Grid>
			<div className={classes.tableBarBottom}>
				<Skeleton height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} width={'60px'} />
			</div>
		</Paper>
	);
};

QuickFiltersSkeleton.propTypes = {
	numberOfRows: PropTypes.number.isRequired,
	withFooter: PropTypes.bool
};

export default QuickFiltersSkeleton;
